import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "container-fluid" };
const _hoisted_2 = { class: "mb-4" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-12 col-lg-3" };
const _hoisted_5 = { class: "h-100 bg-light p-4" };
const _hoisted_6 = { class: "list-unstyled fs-5" };
const _hoisted_7 = { class: "mb-3" };
const _hoisted_8 = { class: "mb-3" };
const _hoisted_9 = ["href"];
const _hoisted_10 = { class: "col-12 col-lg-9" };
const _hoisted_11 = { class: "p-0 p-lg-3" };
const _hoisted_12 = { class: "d-flex justify-content-end" };
const _hoisted_13 = { class: "p-3" };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = { class: "d-flex flex-wrap" };
const _hoisted_16 = ["onClick"];
import axios from 'axios';
import { FilterMatchMode } from '@primevue/core/api';
import { onMounted, ref } from 'vue';
import { observeDOMChanges, sendHeight } from '../Composables/iframeHeightCalculator';
import { cssStyleSheetLoader } from '../Composables/cssStyleSheetLoader';
import ConfiguratorLayout from '../Layouts/ConfiguratorLayout.vue';
import { usePage } from '@inertiajs/vue3';
import { Column, DataTable, TabPanel, TabPanels, Tabs } from 'primevue';
import { formatters } from '@/Composables/formatters';
import { loadTenantConfigs } from '../Composables/standardFunctions';
import { useI18n } from 'vue-i18n';
import { useTrans } from '@/Composables/useTrans';
import CustomerOrder from '../Components/CustomerOrder.vue';
import CustomerDetails from '../Components/CustomerDetails.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CustomerPortal',
    props: {
        tenantId: String,
        componentUuid: String,
        cssFileUrl: {
            type: String,
            default: null
        },
        sessionId: {
            type: String,
            required: true
        },
        countries: {
            type: Object,
            required: true
        },
        languages: {
            type: Object,
            required: true
        },
    },
    setup(__props) {
        let { loadCssStyleSheet } = cssStyleSheetLoader();
        let { formatCurrency, formatDate } = formatters();
        const { t } = useI18n();
        const { trans } = useTrans();
        const props = __props;
        const tableFilter = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        const user = ref(usePage().props.auth.user);
        const loading = ref(false);
        const imprintUrl = ref('');
        const privacyUrl = ref('');
        const tocUrl = ref('');
        const cancellationRightUrl = ref('');
        const currentTab = ref('orders');
        const tabName = ref(t('Bestellungen'));
        const orders = ref([]);
        const selectedOrder = ref(null);
        onMounted(async () => {
            if (props.cssFileUrl) {
                loadCssStyleSheet(props.cssFileUrl);
            }
            //load configs
            imprintUrl.value = await loadTenantConfigs('imprint_url');
            privacyUrl.value = await loadTenantConfigs('privacy_url');
            tocUrl.value = await loadTenantConfigs('toc_url');
            cancellationRightUrl.value = await loadTenantConfigs('cancellation_right_url');
            sendHeight();
            observeDOMChanges();
            loadOrders();
        });
        function loadOrders() {
            loading.value = true;
            axios.post(route('customer.orders.index'))
                .then(function (response) {
                loading.value = false;
                orders.value = response.data.orders;
            })
                .catch(function (error) {
                loading.value = false;
                console.error(error);
            });
        }
        function selectOrders() {
            loadOrders();
            currentTab.value = 'orders';
            selectedOrder.value = null;
            tabName.value = t('Bestellungen');
        }
        function selectOrder(orderUuid) {
            loading.value = true;
            axios.post(route('customer.orders.show', orderUuid))
                .then(function (response) {
                loading.value = false;
                selectedOrder.value = response.data.order;
                currentTab.value = 'order';
                tabName.value = t('Bestellung') + ' ' + selectedOrder.value.orderId;
            })
                .catch(function (error) {
                loading.value = false;
                console.error(error);
            });
        }
        function selectDetails() {
            currentTab.value = 'details';
            selectedOrder.value = null;
            tabName.value = t('Profil & Adressen');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ConfiguratorLayout, null, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("h1", _hoisted_2, _toDisplayString(tabName.value), 1),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("h2", null, _toDisplayString(user.value.firstname) + " " + _toDisplayString(user.value.lastname), 1),
                                    _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1)),
                                    _createElementVNode("ul", _hoisted_6, [
                                        _createElementVNode("li", _hoisted_7, [
                                            _createElementVNode("button", {
                                                class: "btn btn-link p-0 fs-5",
                                                onClick: _cache[0] || (_cache[0] = ($event) => (selectOrders()))
                                            }, _toDisplayString(_unref(t)('Bestellungen')), 1)
                                        ]),
                                        _createElementVNode("li", _hoisted_8, [
                                            _createElementVNode("button", {
                                                class: "btn btn-link p-0 fs-5",
                                                onClick: _cache[1] || (_cache[1] = ($event) => (selectDetails()))
                                            }, _toDisplayString(_unref(t)('Profil & Adressen')), 1)
                                        ]),
                                        _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                                href: _ctx.route('customer.logout')
                                            }, _toDisplayString(_unref(t)('Abmelden')), 9, _hoisted_9)
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createVNode(_unref(Tabs), {
                                    value: currentTab.value,
                                    "onUpdate:value": _cache[4] || (_cache[4] = ($event) => ((currentTab).value = $event))
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(TabPanels), null, {
                                            default: _withCtx(() => [
                                                _createVNode(_unref(TabPanel), { value: "orders" }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_11, [
                                                            _createVNode(_unref(DataTable), {
                                                                dataKey: "id",
                                                                value: orders.value,
                                                                stripedRows: "",
                                                                responsiveLayout: "scroll",
                                                                globalFilterFields: ['status', 'orderId', 'totalPrice', 'totalPriceInclTax', 'totalWeight', 'deliveryDate', 'createdAt'],
                                                                filters: tableFilter.value,
                                                                "onUpdate:filters": _cache[3] || (_cache[3] = ($event) => ((tableFilter).value = $event)),
                                                                paginator: true,
                                                                rows: 10,
                                                                paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                                                                rowsPerPageOptions: [10, 25, 50, 150],
                                                                currentPageReportTemplate: "{first} von {last} von insgesamt {totalRecords}"
                                                            }, {
                                                                header: _withCtx(() => [
                                                                    _createElementVNode("div", _hoisted_12, [
                                                                        _withDirectives(_createElementVNode("input", {
                                                                            type: "text",
                                                                            class: "form-control",
                                                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((tableFilter.value['global'].value) = $event)),
                                                                            placeholder: "Suche",
                                                                            style: { "width": "250px" }
                                                                        }, null, 512), [
                                                                            [_vModelText, tableFilter.value['global'].value]
                                                                        ])
                                                                    ])
                                                                ]),
                                                                empty: _withCtx(() => [
                                                                    _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('Noch keine Bestellungen vorhanden')), 1)
                                                                ]),
                                                                loading: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(_unref(t)('Einträge werden geladen ...')), 1)
                                                                ]),
                                                                default: _withCtx(() => [
                                                                    _createVNode(_unref(Column), {
                                                                        header: "#",
                                                                        sortable: true
                                                                    }, {
                                                                        body: _withCtx((slotProps) => [
                                                                            _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                                                        ]),
                                                                        _: 1
                                                                    }),
                                                                    _createVNode(_unref(Column), {
                                                                        header: _unref(t)('Status'),
                                                                        sortable: true,
                                                                        sortField: "status"
                                                                    }, {
                                                                        body: _withCtx((slotProps) => [
                                                                            _createElementVNode("a", {
                                                                                href: "#",
                                                                                onClick: ($event) => (selectOrder(slotProps.data.uuid))
                                                                            }, _toDisplayString(slotProps.data.status), 9, _hoisted_14)
                                                                        ]),
                                                                        _: 1
                                                                    }, 8, ["header"]),
                                                                    _createVNode(_unref(Column), {
                                                                        field: "orderId",
                                                                        header: _unref(t)('Bestellnr.'),
                                                                        sortable: true,
                                                                        sortField: "orderId"
                                                                    }, null, 8, ["header"]),
                                                                    _createVNode(_unref(Column), {
                                                                        header: _unref(t)('Preis'),
                                                                        sortable: true,
                                                                        sortField: "totalPrice"
                                                                    }, {
                                                                        body: _withCtx((slotProps) => [
                                                                            _createTextVNode(_toDisplayString(_unref(formatCurrency)(slotProps.data.totalPrice)), 1)
                                                                        ]),
                                                                        _: 1
                                                                    }, 8, ["header"]),
                                                                    _createVNode(_unref(Column), {
                                                                        header: _unref(t)('Brutto-Preis'),
                                                                        sortable: true,
                                                                        sortField: "totalPriceInclTax"
                                                                    }, {
                                                                        body: _withCtx((slotProps) => [
                                                                            _createTextVNode(_toDisplayString(_unref(formatCurrency)(slotProps.data.totalPriceInclTax)), 1)
                                                                        ]),
                                                                        _: 1
                                                                    }, 8, ["header"]),
                                                                    _createVNode(_unref(Column), {
                                                                        header: _unref(t)('Gewicht'),
                                                                        sortable: true,
                                                                        sortField: "totalWeight"
                                                                    }, {
                                                                        body: _withCtx((slotProps) => [
                                                                            _createTextVNode(_toDisplayString(slotProps.data.totalWeight / 1000) + " kg ", 1)
                                                                        ]),
                                                                        _: 1
                                                                    }, 8, ["header"]),
                                                                    _createVNode(_unref(Column), {
                                                                        header: _unref(t)('Lieferdatum'),
                                                                        sortable: true,
                                                                        sortField: "deliveryDate"
                                                                    }, {
                                                                        body: _withCtx((slotProps) => [
                                                                            _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.deliveryDate, true)), 1)
                                                                        ]),
                                                                        _: 1
                                                                    }, 8, ["header"]),
                                                                    _createVNode(_unref(Column), {
                                                                        header: _unref(t)('Erstellt'),
                                                                        sortable: true,
                                                                        sortField: "createdAt"
                                                                    }, {
                                                                        body: _withCtx((slotProps) => [
                                                                            _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.createdAt, true)), 1)
                                                                        ]),
                                                                        _: 1
                                                                    }, 8, ["header"]),
                                                                    _createVNode(_unref(Column), { header: "" }, {
                                                                        body: _withCtx((slotProps) => [
                                                                            _createElementVNode("div", _hoisted_15, [
                                                                                _createElementVNode("a", {
                                                                                    href: "#",
                                                                                    onClick: ($event) => (selectOrder(slotProps.data.uuid)),
                                                                                    class: "btn btn-primary d-inline-flex align-items-center"
                                                                                }, [...(_cache[6] || (_cache[6] = [
                                                                                        _createElementVNode("svg", {
                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                            width: "16",
                                                                                            height: "16",
                                                                                            fill: "currentColor",
                                                                                            class: "bi bi-pencil-square text-white",
                                                                                            viewBox: "0 0 16 16"
                                                                                        }, [
                                                                                            _createElementVNode("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }),
                                                                                            _createElementVNode("path", {
                                                                                                "fill-rule": "evenodd",
                                                                                                d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                                                                            })
                                                                                        ], -1)
                                                                                    ]))], 8, _hoisted_16)
                                                                            ])
                                                                        ]),
                                                                        _: 1
                                                                    })
                                                                ]),
                                                                _: 1
                                                            }, 8, ["value", "filters"])
                                                        ])
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_unref(TabPanel), { value: "order" }, {
                                                    default: _withCtx(() => [
                                                        (selectedOrder.value)
                                                            ? (_openBlock(), _createBlock(CustomerOrder, {
                                                                key: 0,
                                                                order: selectedOrder.value
                                                            }, null, 8, ["order"]))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_unref(TabPanel), { value: "details" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(CustomerDetails, {
                                                            countries: __props.countries,
                                                            languages: __props.languages
                                                        }, null, 8, ["countries", "languages"])
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }, 8, ["value"])
                            ])
                        ])
                    ])
                ]),
                _: 1
            }));
        };
    }
});
